<template>
	<gp-screen>

		<template #title>
			Sélectionne la ville de ton choix
		</template>

		<template #content>
			<v-select
				:items="items"
				v-model="ville"
				label="Sélectionner..."
				class="list-select"
				>
			</v-select>
		</template>

		<template #button>
			<gp-btn
				:disabled="$store.getters.ville === ''"
				to="photo"
				>
				Choisir une photo
			</gp-btn>
		</template>

	</gp-screen>
</template>

<script>
import sendEvent from '@/events'

export default {
	data()  {
		return {
			items: [],
			ville: {},
		}
	},
	watch: {
		ville(n) {
			this.$store.dispatch('ville', n)
			return n
		}
	},
	created() {
		let i = []
		const villes = {...this.$store.getters.villes}

		for (let v in villes) {
			i.push({
				text: villes[v],
				value: v
			})
		}

		this.items = i
	},
	beforeRouteLeave(to, from, next) {
		if (to.name === 'photo') {
			sendEvent('ville', this.$store.getters.ville)
		}

		next()
	},
	methods: {
		selectVille(id) {
			this.$store.dispatch('ville', id)
		}
	},
}
</script>